import React from "react";
import Video from "../Video";

export default function UserStream({ stream, user, mute, maximizeUserVideo }) {
  const mediaStream = stream?.current ? stream.current : stream;

  return (
    <div
      className="bg-dark text-white rounded shadow-sm position-relative overflow-hidden"
      style={{ width: "220px", minWidth: "220px", height: "150px", cursor: "pointer" }}
      onClick={() => maximizeUserVideo(stream, user)}
    >
      {/* Video */}
      {mediaStream ? (
        <Video
          stream={mediaStream}
          muted={mute === true}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transform: "rotateY(180deg)"
          }}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100 text-muted small">
          Camera is off
        </div>
      )}

      {/* Header Overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 d-flex align-items-center px-2 py-1"
        style={{
          background: "rgba(0,0,0,0.45)",
          backdropFilter: "blur(2px)"
        }}
      >
        {user?.imageSrc ? (
          <img
            src={user.imageSrc}
            alt="user"
            className="rounded-circle me-2"
            style={{ width: "24px", height: "24px", objectFit: "cover" }}
          />
        ) : (
          <div
            className="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center me-2"
            style={{ width: "24px", height: "24px", fontSize: "12px" }}
          >
            {user?.contactName?.first?.charAt(0)?.toUpperCase()}
          </div>
        )}

        <span className="small text-truncate">
          {user?.contactName?.first} {user?.contactName?.last}
        </span>
      </div>
    </div>
  );
}